import { Component, Input } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'

@Component({
  selector: 'ddc-icon-function',
  templateUrl: './ddc-icon-function.component.html',
  styleUrl: './ddc-icon-function.component.scss',
  imports: [AngularMaterialsModules],
})
export class DdcIconFunctionComponent {
  @Input('icon') _icon: string
  @Input('tooltip') _tooltip: string
}
